<template>
  <optional-field :enabled.sync="enabled" :name="field.name">
    <v-text-field
      :rules="[v => !field.required || !!v || 'This field is required']"
      :type="field.type"
      :append-outer-icon="!field.required ? 'block' : ''"
      @click:append-outer="disable"
      :label="label"
      v-model="localData"></v-text-field>
  </optional-field>
</template>

<script>
import Field from '@/mixins/JsonEditorField'
import OptionalField from './OptionalField'

export default {
  name: 'JsonTextField',
  components: { OptionalField },
  mixins: [Field]
}
</script>
